import AbstractIntegration from "./AbstractIntegration.js";

/**
 * `TfsoIntegration` is a concrete implementation of
 * `AbstractIntegration` for import made with Tfso.
 */
export default class TfsoIntegration extends AbstractIntegration {
	isBeta() {
		return false;
	}

	getName() {
		return "24SevenOffice";
	}

	routeName() {
		return "tfso";
	}

	isTfsoIntegration() {
		return true;
	}

	static getType() {
		return "TfsoIntegration";
	}
}
